module.exports = __webpack_public_path__ + "static/media/about-bottom-one.150c4a6c.jpg";